import React from 'react';
import { Globe, MessageSquare, Phone } from 'react-feather';

const SimUsageDetail = ({ detail }) => {
  return (
    <>
      <div className="mr-4">{`m${detail[0]['month']}`}</div>
      <span className="mr-4">
        <Tag
          icon={<Phone size={16} />}
          label={Math.round(detail[0]['sum(`value`)'] / 60 / 60)}
          style="neutral"
        />
      </span>
      <span className="mr-4">
        <Tag
          icon={<Globe size={16} />}
          label={`${Math.round(detail[1]['sum(`value`)'] / 1024 / 1024)} GB`}
          style="neutral"
        />
      </span>
      <span className="mr-4">
        <Tag
          icon={<MessageSquare size={16} />}
          label={detail[2]['sum(`value`)']}
          style="neutral"
        />
      </span>
    </>
  );
};

export default SimUsageDetail;
